<template>
  <div class="full-height" id="import-file-samae-start">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="q-py-xs">
            <div class="crud-title">
            </div>
          </q-card-section>
          <q-card-section class="q-px-md">
            <jt-dynamic-form
              ref="dynamicForm"
              :inputs="elements[0].inputs"
              :relacionamentos="elements[0].relacionamentos"
              :model="elements[0].dadosForm"
              :interface="elements[0].nmInterface"
              form-class="form dynamic importFileSamaeForms"
              @composition-button-click="actionButtonComposition"
              @composition-modal-close="compositionModalCloseHandler"
              @search-found="
                (event) => {
                  $emit('search-found', event);
                }
              "
              @on-select-change="
                (event) => {
                  $emit('on-select-change', event);
                }
              "
              @on-select-ajax="
                (event) => {
                  $emit('on-select-ajax', event);
                }
              "
            />
          </q-card-section>
        </q-card>
      </div>
    </div>

    <div
      v-if="forms[0] && forms[0].buttons.length"
      class="row full-width q-col-gutter-lg justify-center q-py-md"
    >
      <div class="col-lg-2 col-md-3">
        <q-btn class="full-width" color="grey-7" @click="limparForm">
          <translate>CLEAN</translate>
        </q-btn>
      </div>
      <div
        v-for="(button, i) in forms[0].buttons"
        :key="i"
        :class="`col-lg-2 col-md-3 button-${
          button.name ? button.name.toLowerCase() : button.name
        }`"
      >
        <q-btn
          :class="`full-width button-btn-${
            button.name ? button.name.toLowerCase() : button.name
          }`"
          :color="`${getCollorButton(button.name)}`"
          @click="actionButton(button)"
        >
          <q-icon
            v-if="button.icon"
            :name="button.icon"
            size="18px"
            class="position-icon-filter"
          />
          {{ button.label }}
        </q-btn>
      </div>
    </div>

    <q-card class="q-px-sm card-crud">
          <q-card-section class="q-py-sm card-title">
            <div class="crud-title">
              <translate>SEARCH_IMPORT</translate>
            </div>
          </q-card-section>
          <q-card-section class="q-pb-lg card-table">
            <jt-data-table
              v-if="datatable"
              ref="jtDataTable"
              class="table-file-samae"
              :forms="forms"
              :buttons="datatable.buttons"
              :buttons-filter="filterButtons"
              :fields="datatable.columns"
              :extra-params="extraParam"
              :default-http-options="defaultHttpOptions"
              nm-interface="samae.pesquisarFile"
              singleselect
              :row-buttons="true"
              :selection-force="selectionForce"
              :column-edit="columnEdit"
              :row-set="rowSet"
              :bottom-edit="bottomEdit"
              :multiselect="multiselect"
              :noneselect="noneselect"
              @selection="selection"
              @action-button="actionButtonTable"
              @show-message="showMessage"
              @click-row="
                (row) => {
                  $emit('click-row', row)
                }
              "
            >
            </jt-data-table>

          </q-card-section>
        </q-card>

  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDynamicForm, JtechDataTableUtils } from 'jtech-webcomps'

@Component({
  name: 'pageStart',
  components: { JtDynamicForm },
  props: {
    params: { type: Object, required: true },
    datatable: { type: Object, required: true },
    name: String,
    page: String,
    label: String,
    labelPage: String,
    forms: { type: Array, required: true },
    parent: Object
  }
})
class CrudLayoutPage extends Vue {
  get elements () {
    return this.forms
  }

  getParams () {
    return this.forms[0].dadosForm
  }

  getCollorButton (name) {
    return name == 'btExportar' ? 'blue' : 'info'
  }

  limparForm () {
    Array.isArray(this.$refs.dynamicForm)
      ? this.$refs.dynamicForm[0].resetForm()
      : this.$refs.dynamicForm.resetForm()
    this.$emit('form-reset', { form: this.$refs.dynamicForm, page: this })
  }

  isValidForm () {
    return Array.isArray(this.$refs.dynamicForm)
      ? this.$refs.dynamicForm[0].isValidForm()
      : this.$refs.dynamicForm.isValidForm()
  }

  processClasses () {
    return 'col-' + 12 / (this.forms[0].buttons.length + 1) + ' q-pa-md'
  }

  actionButton (button) {
    if (!this.isButtonValidForm(button) || this.isValidForm()) {
      this.$emit('action-button', button, this.getParams(), this)
    } else {
      this.$emit('show-message', 'warning', 'REQUIRED_FIELDS_NOT_FILLED', this)
    }
  }

  actionButtonComposition (button) {
    this.$emit('composition-button-click', button)
  }

  compositionModalCloseHandler (f) {
    this.$emit('composition-modal-close', f)
  }

  isButtonValidForm (button) {
    return button.name.indexOf('btCancelar') < 0
  }

  filterButtons (button, dados) {
    return JtechDataTableUtils.filterButtons(button, dados)
  }

  actionButtonTable (button, params) {
    this.$emit('action-button', button, params, this)
  }
}
export default CrudLayoutPage
</script>
<style lang="stylus">
@import '~quasar-variables';

.importFileSamaeForms {
  #scroll-area {
    height: calc(20vh - 1px) !important;
  }
}

.table-file-samae {
  .jt-datatable {
    height: 45vh !important;
  }
}

</style>
